<template>
  <section class="dk--bot-section">
    <div v-if="store.error">
      <h5>...</h5>
<!--      <pre>{{ store.error }}</pre>-->
    </div>

    <DkBotMessages/>
    <div class="dk--bot-bottom"></div>
  </section>
</template>

<script>
import DkBotMessages from './components/DkBotMessages.vue';
import { store } from './store.js';

export default {
  name: 'DkBot',
  components: {
    DkBotMessages,
  },
  props: {
    dkBotContainerId: String,
    dkBot: String,
    dkBotName: String,
    dkBotImageUrl: String,
    dkBotGtmStartEvent: String,
    dkBotGtmSubmitEvent: String,
  },
  data() {
    return {
      store,
    };
  },
  created() {
    this.store.startBot(this.dkBot, this.dkBotName, this.dkBotImageUrl, {
      start: this.dkBotGtmStartEvent,
      submit: this.dkBotGtmSubmitEvent,
    });

    const scrollToBot = new URLSearchParams(document.location.search).get('bot');

    if (scrollToBot !== null) {
      document
        .getElementById(this.dkBotContainerId)
        .scrollIntoView({
            behavior: "instant",
            block: "center",
            inline: "nearest"
          }
        );
    }
  }
}
</script>

<style lang="scss">
:root {
  /**
   * colors
   */

  /*
  --dk--bot-msg-bg-color: #eaf4e5;
  --dk--bot-msg-color: #333;

  --dk--bot-input-placeholder-color: #b8b8b8;

  --dk--bot-answer-color: #46a805;
  --dk--bot-answer-bg-color: #fff;
  */

  --dk--bot-msg-bg-color: #eee;
  --dk--bot-msg-color: #333;

  --dk--bot-input-placeholder-color: #b8b8b8;

  --dk--bot-answer-color: #333;
  --dk--bot-answer-bg-color: #fff;
  --dk--bot-answer-border-color: var(--dk--bot-answer-color);

  --dk--bot-answered-color: var(--dk--bot-answer-bg-color);
  --dk--bot-answered-bg-color: var(--dk--bot-answer-color);

  /**
   * animations, transitions
   */
  --dk--bot-section-transition: all 180ms ease-in-out;
  --dk--bot-answered-transition: all 150ms ease-out;

  /**
   * font
   */
  --dk--bot-font-family: sans-serif;
  --dk--bot-msg-font-size: 14px;
  --dk--bot-msg-font-size--lg: 15px;

  /**
   * sizes, gaps, margin, paddings etc
   */
  --dk--bot-section-max-width: 600px;
  --dk--bot-section-margin: auto;
  --dk--bot-section-padding: 10px 0;

  --dk--bot-msg-padding: 8px;
  --dk--bot-msg-padding--lg: 9px;

  --dk--bot-msg-space: 17px;
  --dk--bot-msg-space-after-msg-only: 10px;

  --dk--bot-avatar-width: 40px;
  --dk--bot-avatar-width--lg: 42px;
  --dk--bot-msg-avatar-gap: 7px;
  --dk--bot-msg-avatar-gap--lg: 9px;
  --dk--bot-answer-avatar-gap: 5px;
  --dk--bot-answer-avatar-gap--lg: 20px;

  --dk--bot-answer-height: 34px;
  --dk--bot-answer-min-width: 42px;

  /**
   * border-radius's
   */
  --dk--bot-msg-border-radius: 7px;
  --dk--bot-answer-border-radius: 90px;
  --dk--bot-input-border-radius: var(--dk--bot-answer-border-radius);
}

.dk--bot-section {
  font-family: var(--dk--bot-font-family);
  max-width: var(--dk--bot-section-max-width);
  margin: var(--dk--bot-section-margin);
  height: auto;
  padding: var(--dk--bot-section-padding);
  transition: var(--dk--bot-section-transition);
  overflow: hidden;
  box-sizing: content-box !important;
  text-align: left;
}

</style>
